webpackJsonp([114276838955818,60335399758886],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/layout-index.json":
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"gitRepo":"cp-website"}},"allPrismicDocument":{"edges":[{"node":{"type":"feature","fields":{"permalink":"/features/drag-and-drop-rostering"},"data":{"feature_name":[{"type":"heading1","text":"Drag and Drop Rostering"}],"title":null,"company_name":null}}},{"node":{"type":"case_study","fields":{"permalink":"/case-studies/woodfield24"},"data":{"feature_name":null,"title":null,"company_name":[{"type":"heading1","text":"Woodfield24"}]}}},{"node":{"type":"feature","fields":{"permalink":"/features/call-monitoring"},"data":{"feature_name":[{"type":"heading1","text":"Call Monitoring"}],"title":null,"company_name":null}}},{"node":{"type":"case_study","fields":{"permalink":"/case-studies/county-care"},"data":{"feature_name":null,"title":null,"company_name":[{"type":"heading1","text":"County Care"}]}}},{"node":{"type":"feature","fields":{"permalink":"/features/mobile"},"data":{"feature_name":[{"type":"heading1","text":"Mobile"}],"title":null,"company_name":null}}},{"node":{"type":"case_study","fields":{"permalink":"/case-studies/sos-homecare"},"data":{"feature_name":null,"title":null,"company_name":[{"type":"heading1","text":"SOS Homecare"}]}}},{"node":{"type":"feature","fields":{"permalink":"/features/travel"},"data":{"feature_name":[{"type":"heading1","text":"Travel"}],"title":null,"company_name":null}}},{"node":{"type":"case_study","fields":{"permalink":"/case-studies/charlesworth-community-care"},"data":{"feature_name":null,"title":null,"company_name":[{"type":"heading1","text":"Charlesworth Community Care"}]}}},{"node":{"type":"feature","fields":{"permalink":"/features/secure-cloud-based-system"},"data":{"feature_name":[{"type":"heading1","text":"Secure, Cloud-based System"}],"title":null,"company_name":null}}},{"node":{"type":"case_study","fields":{"permalink":"/case-studies/proud-to-care"},"data":{"feature_name":null,"title":null,"company_name":[{"type":"heading1","text":"Proud To Care"}]}}},{"node":{"type":"feature","fields":{"permalink":"/features/invoicing-and-payments"},"data":{"feature_name":[{"type":"heading1","text":"Invoicing and Payments"}],"title":null,"company_name":null}}},{"node":{"type":"feature","fields":{"permalink":"/features/reporting"},"data":{"feature_name":[{"type":"heading1","text":"Reporting"}],"title":null,"company_name":null}}},{"node":{"type":"feature","fields":{"permalink":"/features/communication"},"data":{"feature_name":[{"type":"heading1","text":"Communication"}],"title":null,"company_name":null}}},{"node":{"type":"feature","fields":{"permalink":"/features/record-keeping"},"data":{"feature_name":[{"type":"heading1","text":"Record Keeping"}],"title":null,"company_name":null}}},{"node":{"type":"feature","fields":{"permalink":"/features/customisation"},"data":{"feature_name":[{"type":"heading1","text":"Customisation"}],"title":null,"company_name":null}}},{"node":{"type":"blog_post","fields":{"permalink":"/blog/who-cares-about-social-care"},"data":{"feature_name":null,"title":[{"type":"heading1","text":"Who Cares About Social Care?"}],"company_name":null}}},{"node":{"type":"page","fields":{"permalink":"/shiftplanning-software"},"data":{"feature_name":null,"title":[{"type":"heading1","text":"Shiftplanning Software"}],"company_name":null}}},{"node":{"type":"page","fields":{"permalink":"/terms-and-conditions"},"data":{"feature_name":null,"title":[{"type":"heading1","text":"Terms and Conditions"}],"company_name":null}}},{"node":{"type":"page","fields":{"permalink":"/software-for-home-care-services"},"data":{"feature_name":null,"title":[{"type":"heading1","text":"Software for Home Care Services"}],"company_name":null}}}]}},"layoutContext":{}}

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./.cache/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__("./src/layouts/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/layout-index.json");
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return Glamor.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/assets/cp-logo-blue.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cp-logo-blue.decb03cf.png";

/***/ }),

/***/ "./src/assets/cp-logo-white.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cp-logo-white.60eddd76.png";

/***/ }),

/***/ "./src/assets/favicon.ico":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.89c5e15c.ico";

/***/ }),

/***/ "./src/assets/linkedin-circle.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./src/assets/linkedin-square-white.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAABMpJREFUaAXlm0toVUcYx73xnfigWN+C0ZW40GpBEUQUtVVc+MKFihbUoghCXdtdoT7QpUppF1UXggtNqYoIapZqVFRcCKImINIigo3VJgYbf//rOeHe68ydGe/JzTk3H/wzj++bx39mzsx35tzkBhiku7t7OtkzwUgwCAwBw0FDFA4lHAyUL1E8TivsjiC90iHyDuMukIvQWZBW/D1Q/XH+G+IdQKHyVL4dPMjlcq2EdoHoTHAatIOsyysI/A4aCxlrFPOC4hsip8C4jzk18/cJTDYw23fEKE8YsrOIXwVjlFmD8hROSyDdVgfZOhIHQa2S1fxNAz8pkoPwHMIbIHRzUfksyb90drZmdyeodbKamBHgKxGerFQ/kVEirHOtv8gIEe5PMlpe1OfIdQrdigpqB1wM5IWlXepDCWun2wtOcKbJ/csLO/3XRH4F2vHTLMNClvT/MNkD0d8KyYod6dsE68EzpVMs9SGEmyFywkYG0vJmjtv0KckfEkL4JqT0llJO5J5qJaRVhoYQ7nlmy7DRM55mwnUhhCeUIRqrphMJ3QjjstUIB4YQXslu7CK9tRq9rqCNoCU9hYaOQlo+6SdC/i4y13yiSFlG6PJbR/8nQu4A4U2g65RGoBeQHSBkxWBefQklrB4uAH+AF0Ab2Zcgvtsimm75HMIxo7FxJEthJYR7k6eOt7+BbiNzQLeko4FWU0USQljn60nwF1AnSkV534HxJYprpPWyYXu+t6CbFJV5THgM/Ameg/js1yOjzVK++jawFgwE4cIG1AR8pAujGeVaQN9iqGiPo8z1qMwxQq/HBLtVoC0qFxI02Ubd1kddxhuFVlWXqT7rhhaV0Srbh9u6G2gjdAp2FzBaBdqcxiUGpg6WmPRqUoNxCAI/h7ZCmQeU2QXiZe9VRV8T7qTjZ7x6ajCi7CWyzxlU1qw+JUyHXW9f1o4XKH4h7v3C0qeECzrdE+W5bgBG97XHqDgij6+1OMueSg1hSK4A8uDugfvEz4Ol9q5/1LBKdGbfd9nF+pBzOC6TeAixH6j0CCicgGmkl6HbBKmzjkblG3hJYQNeBZI2gtBc6twPTH2Rh3UYmy8c7eq7sJeYGvEqmKDRZuoaVqY+zfS3ZfRSeR9NaSA81UFGatc3a++vJ2kgbPXeCgbCdey49D1VpYGwz8bpelHI1AzrLcslLhtvByYrM+waEG99Ggi7Zk9kXEs6U4SrOuhVbcwyDT4znFg/E6vIQiap7MT6mVhFFTBL7Pn06ENnGgh79DOxTet9Ggj7PMM+Nj4Dl7948zHsFRvegkSkmoPeUc3GKhm0pJ7zrlDC+hJgFF7S5cCbnHh9cDNKdKfl4xa6Xv9c+rj9tz6Oe2yswdnOMnwWZ5SEWp6m78e6tVBZ03OovPirQ0l1RclF1PHWUocGbGGRtT3RoR+XNqFfbbepKc2PoUs66+zbRbg/kX4tsi+zPm0B/X8jwrq5974xCKg8bab/0aF7ItwCmkGty0UIPsofFezU80lcAQ01yloX9Us49x/mNywi+p+H78HrGiSsn05sFFlxyxNWhIzTBMvBZWD1jtBlRcThPFgOt+a40ybvZwBLfA4G80Aj0I9JhHpgtCe/r0Xelv4V7x/wCrSCFojeJSySDw51VsRvffoFAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./src/assets/twitter-circle.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./src/assets/twitter-white.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAyCAYAAAAA9rgCAAAAAXNSR0IArs4c6QAABVBJREFUaAXVmmuIFWUYx/ekq3kPtfC2IhFpWLmQLm5aGmJRCbHIZki6QeWXEEEsXZD0QwT6IREUpCX1U+SlVCgy0UCtvCyWirfYLrqY5q5m3lYtdf39YWacc/adyznOzJnzwI935n2f93me/5y5vLOzZWUptPb29m5QBW/D9yBrgDdgBGRSWHb+JSFkIHwIR+E2mKyNzl3wFjwYlAWfHjAZOht9GehjHIi5k7x10Az52B6cq02l0d8bZsJh+NjkU8ZAF9gBU4wOMXSSqzN8AoXaZSbOUGm0PWE8LIEmkF2EwcbSGZgkD+wcPGN0iriTPMuV8D7tJvO/hd8NcWZ7lozzCteEk2w/5ekcwQDxZ7nyxbG5jqCe124nBhtzskr0mAi0dQhB3GFwPidflLtbCFauxLS6nmuh0imEnb5wFnKthY5XHceINogZxamcW6v2dXqvgVEwFVbBKdgM3Zzy2akA3QBMdp3OuRDJ8484/eFviMP02DoBV1zB9Zh72BGrDTok+JLLybSpa6Iia2IBO8SoMQWPqU+X5Qi7zAfsDdorcM21b9p8nc4fCFAH7rkmX78+47PTb0KBY6eYV5PJZE7Y891FX6az2R7waYcytha2InqCj5/f0GN+gxGNHSTOy4j9xR3PEczAHQb2uAcDticzrkXKV6Dnd6cAf/dw3Ku5HSR7EU3H3Um17Qi2BjbRtlvbYRqJrIHtoPXtezCM7SDTwY3TdiO21ZQgV/BPOP1ocgzR9yw+K+AgonW6z4Nq6GeY+5ehL8qurl7BslYhHJVbFLgY5+8gn1PUHV+n60sW6tez/Q/a3+Ck9uEhiNP+9wqeJVhOiNZ1uZzNuV6T8uwfiL8Yl+e8+3HXE8dozimNyF5gn37z8N5gnFEanRe8ynQE4/Ao7EX0R7SjYQ6shltQanbGq2BnqYjQoTjpAa31pu6izaDrTQvue2tQdlJuun4ruTSPmep0C+6KwyEYbnIsoT49AUYi+JKpZueUxuEmDntNTiXW1+QlVjocwZaojSUmzlRuo6nT7ssVrBXTz/Zgiba7/OrOEsypcAPnRZDP8tIvftJj50m43y9plmA5IvprmpV+k1I8pjV0i199HQRbzh/Q6kWi1CzwHmQUzFG6jtI34bMSUqzFxtageo2CNQnRbfAOm3WghX/abT31/hNUpLPw8HNkFaZFSS1Mh+ehB6TJdEaORrBxdeUutMPbkj2ISP36Wlf3hasg0XplTOMdfGMYsdRe5imYAHcQreVZvRxTbG3UtjRsfZ7XsBWggfbPsMGK5NfAj3MkbO7Aa5hfeRrBvggbMGG/ZvJVIfhc2LxBv7Du1usItixswIT95ucjNnRt/MrloG80abK1oQUU4ojSDLwP7m82xToAh0ls/zmqEDnh55CoEj6HYglvVQ3hK872DLxpZbvf2yPp4+xNgioYAmOhJ8RpWmDUct1+E2eSwNiIXwjXIE7Td1+t9IpnFDAOdsap0oqtg1k8sSTX1/XVoKMet+kfbF5J/GclaT/Qh+wvQV/Zk7ADJBkVpVg9anoRUG8/+j58G/SCoP9w00uD/lathPpQVg2DIQnTC8qnUM8N6mKUCfXy0AXeBS0hJVx/hO8Ova2WJlHTunghQrfEmpVfeiLoM2ex7DSJF0CfWIXmBifhC7ABrkIS9itJ6kFfGGM3z4UHBTxB9qnwGug6LoeoTG83O2E9bOP09fy8GVVCO46nYNsB4brOR8JzMB6eBq2sdLMLY//h1ApN0Ai7YR8iW2gTt0DBuRVxAPSnngFQAYPgEXgStMzUwdlnoW+0Z0Eft84g8F/aottd6dSPc3wBHVsAAAAASUVORK5CYII="

/***/ }),

/***/ "./src/components/blog-footer.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return Glamor.createElement(
	    'div',
	    { css: styles.container },
	    Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(
	        'a',
	        { href: 'https://twitter.com/careplannerltd', target: '_blank', css: styles.socialIcon },
	        Glamor.createElement('img', { src: __webpack_require__("./src/assets/twitter-circle.png") })
	      ),
	      Glamor.createElement(
	        'a',
	        { href: 'https://www.linkedin.com/company/3239311/', target: '_blank', css: styles.socialIcon },
	        Glamor.createElement('img', { src: __webpack_require__("./src/assets/linkedin-circle.png") })
	      )
	    ),
	    Glamor.createElement(
	      'div',
	      { css: styles.copyright },
	      '\xA9 ',
	      new Date().getFullYear(),
	      ' CarePlanner, All Rights Reserved'
	    )
	  );
	};
	
	var styles = {
	  container: {
	    textAlign: 'center',
	    padding: '40px',
	    backgroundColor: '#F4F8FC'
	  },
	  socialIcon: {
	    '> img': {
	      height: '30px'
	    },
	    ':first-child': {
	      '> img': {
	        marginRight: '20px'
	      }
	    }
	  },
	  copyright: {
	    marginTop: '20px'
	  }
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/blog-navbar.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _navbarInner, _hamburger, _beforeAfter, _hamburgerIcon, _rightNavContainer, _logo, _logoContainer;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _button = __webpack_require__("./src/components/button.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogNavbar = function (_React$Component) {
	  _inherits(BlogNavbar, _React$Component);
	
	  function BlogNavbar() {
	    _classCallCheck(this, BlogNavbar);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      collapsed: true
	    };
	    return _this;
	  }
	
	  BlogNavbar.prototype.toggleMenu = function toggleMenu() {
	    this.setState({ collapsed: !this.state.collapsed });
	  };
	
	  BlogNavbar.prototype.render = function render() {
	    var subnav = Glamor.createElement(
	      'div',
	      { css: styles.subnav },
	      Glamor.createElement(
	        'div',
	        { css: styles.subnavInner },
	        Glamor.createElement(
	          _gatsbyLink2.default,
	          { css: styles.subnavInnerLink, activeClassName: 'active', to: '/features' },
	          'Latest'
	        ),
	        Glamor.createElement(
	          _gatsbyLink2.default,
	          { css: styles.subnavInnerLink, activeClassName: 'active', to: '/case-studies' },
	          'Industry'
	        )
	      )
	    );
	
	    return Glamor.createElement(
	      'div',
	      { css: styles.navbarContainer },
	      Glamor.createElement(
	        'nav',
	        { css: styles.navbar },
	        Glamor.createElement(
	          'div',
	          { css: styles.navbarInner },
	          Glamor.createElement(
	            'a',
	            { css: styles.hamburger, onClick: this.toggleMenu.bind(this) },
	            Glamor.createElement('span', { css: styles.hamburgerIcon })
	          ),
	          Glamor.createElement(
	            _gatsbyLink2.default,
	            { to: '/blog' },
	            Glamor.createElement(
	              'div',
	              { css: styles.logoContainer },
	              Glamor.createElement('img', { css: styles.logo, src: __webpack_require__("./src/assets/cp-logo-white.png") }),
	              Glamor.createElement('div', { css: styles.logoBar }),
	              Glamor.createElement(
	                'div',
	                { css: styles.logoText },
	                'News'
	              )
	            )
	          ),
	          Glamor.createElement(
	            'div',
	            _extends({ css: styles.rightNavContainer }, { 'data-navbar-open': !this.state.collapsed }),
	            Glamor.createElement(
	              'a',
	              { href: 'https://www.linkedin.com/company/3239311/', target: '_blank' },
	              Glamor.createElement('img', { css: styles.navbarSocialIcon, src: __webpack_require__("./src/assets/linkedin-square-white.png") })
	            ),
	            Glamor.createElement(
	              'a',
	              { href: 'https://twitter.com/careplannerltd', target: '_blank' },
	              Glamor.createElement('img', { css: styles.navbarSocialIcon, src: __webpack_require__("./src/assets/twitter-white.png") })
	            ),
	            Glamor.createElement(
	              _gatsbyLink2.default,
	              { css: [_button.buttonStyle.button, _button.buttonStyle.outline], style: styles.navbarButton, to: '/' },
	              'Back to care-planner.co.uk'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return BlogNavbar;
	}(_react2.default.Component);
	
	exports.default = BlogNavbar;
	;
	
	var styles = {
	  navbarContainer: {
	    position: 'fixed',
	    top: '0',
	    width: '100%',
	    zIndex: '1000',
	    boxShadow: '0 2px 4px #DDE5ED'
	  },
	  navbar: {
	    width: '100%',
	    height: '60px',
	    backgroundColor: '#70A4DB'
	  },
	  navbarInner: (_navbarInner = {
	    height: '100%',
	    margin: '0 auto'
	  }, _navbarInner[_presets2.default.Desktop] = {
	    width: '1000px'
	  }, _navbarInner[_presets2.default.Tablet] = {
	    paddingLeft: '20px',
	    paddingRight: '20px'
	  }, _navbarInner[_presets2.default.Mobile] = {
	    paddingLeft: '20px',
	    paddingRight: '20px'
	  }, _navbarInner),
	  hamburger: (_hamburger = {}, _hamburger[_presets2.default.Desktop] = {
	    display: 'none'
	  }, _hamburger[_presets2.default.Tablet] = {
	    display: 'none'
	  }, _hamburger[_presets2.default.Mobile] = {
	    display: 'inline-block',
	    verticalAlign: 'middle',
	    position: 'relative',
	    height: '30px',
	    width: '30px',
	    margin: '15px 0'
	  }, _hamburger),
	  hamburgerIcon: (_hamburgerIcon = {}, _hamburgerIcon[_presets2.default.Desktop] = {
	    display: 'none'
	  }, _hamburgerIcon[_presets2.default.Tablet] = {
	    display: 'none'
	  }, _hamburgerIcon[_presets2.default.Mobile] = {
	    position: 'absolute',
	    marginTop: '15px',
	    display: 'inline-block',
	    width: '30px',
	    height: '2px',
	    borderTop: '2px solid #FFFFFF',
	    '-webkit-transition': 'border-color .1s',
	    transition: 'border-color .1s',
	    '::before, ::after': (_beforeAfter = {
	      content: '""',
	      position: 'absolute',
	      borderTop: '2px solid #FFFFFF',
	      height: 0,
	      left: 0,
	      right: 0,
	      '-webkit-transition': '-webkit-transform .2s',
	      transition: '-webkit-transform .2s'
	    }, _beforeAfter['transition'] = 'transform .2s', _beforeAfter['transition'] = 'transform .2s, -webkit-transform .2s', _beforeAfter)
	  }, _hamburgerIcon['::before'] = {
	    top: '-10px'
	  }, _hamburgerIcon['::after'] = {
	    bottom: '-6px'
	  }, _hamburgerIcon),
	  rightNavContainer: (_rightNavContainer = {
	    float: 'right',
	    paddingTop: '9px',
	    paddingBottom: '8px'
	  }, _rightNavContainer[_presets2.default.Mobile] = {
	    display: 'block',
	    marginLeft: '-20px',
	    marginRight: '-20px',
	    paddingTop: '0px',
	    paddingBottom: '0px',
	    float: 'none',
	    height: '0px',
	    overflowY: 'hidden',
	    backgroundColor: '#4F739A',
	    '-webkit-transition': 'height .2s ease-out, padding-top .2s ease-out, padding-bottom .2s ease-out',
	    '-moz-transition': 'height .2s ease-out, padding-top .2s ease-out, padding-bottom .2s ease-out',
	    '-ms-transition': 'height .2s ease-out, padding-top .2s ease-out, padding-bottom .2s ease-out',
	    '-o-transition': 'height .2s ease-out, padding-top .2s ease-out, padding-bottom .2s ease-out',
	    transition: 'height .2s ease-out',
	    '&[data-navbar-open=true]': {
	      height: '65px'
	    },
	    '> *': {
	      display: 'inline-block',
	      paddingTop: '10px',
	      paddingBottom: '10px'
	    },
	    '> *:first-child': {
	      marginLeft: '20px'
	    }
	  }, _rightNavContainer),
	  navbarButton: {
	    marginTop: 0,
	    marginBottom: 0,
	    marginRight: 0,
	    verticalAlign: 'middle'
	  },
	  subnav: {
	    width: '100%',
	    height: '48px',
	    backgroundColor: '#F4F8FC'
	  },
	  subnavInner: {
	    width: '1000px',
	    height: '100%',
	    margin: '0 auto'
	  },
	  subnavInnerLink: {
	    display: 'block',
	    float: 'left',
	    color: '#4F739A',
	    padding: '15px 20px 14px 0',
	    margin: '0',
	    minWidth: '80px',
	    textDecoration: 'none',
	    userSelect: 'none',
	    '-moz-user-select': 'none',
	    '-webkit-user-select': 'none',
	    '-ms-user-select': 'none'
	  },
	  logo: (_logo = {}, _logo[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'middle',
	    width: '134px',
	    height: '32px',
	    marginBottom: 0,
	    userSelect: 'none',
	    '-moz-user-select': 'none',
	    '-webkit-user-select': 'none',
	    '-ms-user-select': 'none'
	  }, _logo[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    width: '134px',
	    height: '32px',
	    marginBottom: 0,
	    userSelect: 'none',
	    '-moz-user-select': 'none',
	    '-webkit-user-select': 'none',
	    '-ms-user-select': 'none'
	  }, _logo[_presets2.default.Mobile] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    width: '134px',
	    height: '32px',
	    marginBottom: 0,
	    userSelect: 'none',
	    '-moz-user-select': 'none',
	    '-webkit-user-select': 'none',
	    '-ms-user-select': 'none'
	  }, _logo),
	  logoBar: {
	    display: 'inline-block',
	    verticalAlign: 'middle',
	    height: '32px',
	    marginLeft: '15px',
	    marginRight: '15px',
	    borderLeft: '1px #FFFFFF solid'
	  },
	  logoText: {
	    display: 'inline-block',
	    verticalAlign: 'middle',
	    color: '#FFFFFF',
	    fontSize: '20px'
	  },
	  logoContainer: (_logoContainer = {
	    display: 'inline-block',
	    marginTop: '14px',
	    marginBottom: '14px',
	    userSelect: 'none',
	    '-moz-user-select': 'none',
	    '-webkit-user-select': 'none',
	    '-ms-user-select': 'none'
	  }, _logoContainer[_presets2.default.Mobile] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    marginLeft: 'calc(50% - 125px)'
	  }, _logoContainer),
	  navbarSocialIcon: {
	    height: '25px',
	    marginRight: '35px',
	    marginBottom: 0,
	    verticalAlign: 'middle'
	  }
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/sales-footer.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _column, _a;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _globalStyles = __webpack_require__("./src/utils/global-styles.js");
	
	var _globalStyles2 = _interopRequireDefault(_globalStyles);
	
	var _prismicDom = __webpack_require__("./node_modules/prismic-dom/dist/prismic-dom.min.js");
	
	var _prismicDom2 = _interopRequireDefault(_prismicDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var caseStudies = [];
	    var features = [];
	
	    _this.props.navigation.map(function (node) {
	      var item = node.node;
	      switch (item.type) {
	        case 'case_study':
	          caseStudies.push({
	            link: item.fields.permalink,
	            title: _prismicDom2.default.RichText.asText(item.data.company_name)
	          });
	          break;
	        case 'feature':
	          features.push({
	            link: item.fields.permalink,
	            title: _prismicDom2.default.RichText.asText(item.data.feature_name)
	          });
	          break;
	      }
	    });
	
	    _this.state = {
	      links: {
	        features: features,
	        caseStudies: caseStudies,
	        company: [{ link: "/terms-and-conditions", title: 'Terms and Conditions' }, { link: "/contact-us", title: 'Contact Us' }]
	      }
	    };
	    return _this;
	  }
	
	  Footer.prototype.renderLink = function renderLink(data, i) {
	    return Glamor.createElement(
	      'div',
	      { css: styles.item, key: i },
	      Glamor.createElement(
	        _gatsbyLink2.default,
	        { to: data.link },
	        data.title
	      )
	    );
	  };
	
	  Footer.prototype.render = function render() {
	    return Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(
	        'div',
	        { css: _globalStyles2.default.container },
	        Glamor.createElement(
	          'div',
	          { style: styles.links },
	          Glamor.createElement(
	            'div',
	            { css: styles.column },
	            Glamor.createElement(
	              'div',
	              { css: styles.item },
	              Glamor.createElement(
	                _gatsbyLink2.default,
	                { to: '/features' },
	                Glamor.createElement(
	                  'h5',
	                  null,
	                  'Features'
	                )
	              )
	            ),
	            this.state.links.features.map(this.renderLink)
	          ),
	          Glamor.createElement(
	            'div',
	            { css: styles.column },
	            Glamor.createElement(
	              'div',
	              { css: styles.item },
	              Glamor.createElement(
	                _gatsbyLink2.default,
	                { to: '/case-studies' },
	                Glamor.createElement(
	                  'h5',
	                  null,
	                  'Case Studies'
	                )
	              )
	            ),
	            this.state.links.caseStudies.map(this.renderLink)
	          ),
	          Glamor.createElement(
	            'div',
	            { css: styles.column },
	            Glamor.createElement(
	              'div',
	              { css: styles.item },
	              Glamor.createElement(
	                'h5',
	                null,
	                'Company'
	              )
	            ),
	            this.state.links.company.map(this.renderLink)
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { style: styles.copyright },
	        '\xA9 ',
	        new Date().getFullYear(),
	        ' CarePlanner, All Rights Reserved'
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	
	
	var styles = {
	  copyright: {
	    width: '100%',
	    float: 'left',
	    textAlign: 'center',
	    margin: '40px 0 40px 0'
	  },
	  links: {
	    margin: '40px 5%',
	    width: '90%'
	  },
	  column: (_column = {
	    display: 'inline-block',
	    verticalAlign: 'top'
	  }, _column[_presets2.default.Desktop] = {
	    width: '33%'
	  }, _column[_presets2.default.Tablet] = {
	    width: '33%'
	  }, _column[_presets2.default.Mobile] = {
	    width: '49%'
	  }, _column),
	  item: {
	    marginBottom: '20px',
	    '> h5': {
	      color: '#4F739A'
	    },
	    '> a': (_a = {
	      color: '#4F739A',
	      textDecoration: 'underline'
	    }, _a[_presets2.default.Mobile] = {
	      lineHeight: '24px'
	    }, _a)
	  }
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/sales-navbar.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _navbar, _hamburger, _beforeAfter, _beforeAfter2, _hamburgerIcon, _actions, _links, _buttons, _link, _logo;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _cpLogoBlue = __webpack_require__("./src/assets/cp-logo-blue.png");
	
	var _cpLogoBlue2 = _interopRequireDefault(_cpLogoBlue);
	
	var _button = __webpack_require__("./src/components/button.js");
	
	var _globalStyles = __webpack_require__("./src/utils/global-styles.js");
	
	var _globalStyles2 = _interopRequireDefault(_globalStyles);
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navbar = function (_React$Component) {
	  _inherits(Navbar, _React$Component);
	
	  function Navbar() {
	    _classCallCheck(this, Navbar);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      collapsed: true
	    };
	    return _this;
	  }
	
	  Navbar.prototype.toggleMenu = function toggleMenu() {
	    this.setState({ collapsed: !this.state.collapsed });
	  };
	
	  Navbar.prototype.render = function render() {
	    return Glamor.createElement(
	      'nav',
	      { css: style.navbar },
	      Glamor.createElement(
	        'div',
	        { style: style.inner },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          Glamor.createElement(
	            'a',
	            { css: style.hamburger, onClick: this.toggleMenu.bind(this) },
	            Glamor.createElement('span', { css: style.hamburgerIcon })
	          ),
	          Glamor.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            Glamor.createElement('img', { css: style.logo, src: _cpLogoBlue2.default })
	          ),
	          Glamor.createElement(
	            'div',
	            _extends({ css: style.actions }, { 'data-navbar-open': !this.state.collapsed }),
	            Glamor.createElement(
	              'ul',
	              { css: style.links },
	              Glamor.createElement(
	                'li',
	                null,
	                Glamor.createElement(
	                  _gatsbyLink2.default,
	                  { css: style.link, activeClassName: 'active', to: '/features' },
	                  'Features'
	                )
	              ),
	              Glamor.createElement(
	                'li',
	                null,
	                Glamor.createElement(
	                  _gatsbyLink2.default,
	                  { css: style.link, activeClassName: 'active', to: '/case-studies' },
	                  'Case Studies'
	                )
	              ),
	              Glamor.createElement(
	                'li',
	                null,
	                Glamor.createElement(
	                  _gatsbyLink2.default,
	                  { css: style.link, activeClassName: 'active', to: '/blog' },
	                  'News'
	                )
	              ),
	              Glamor.createElement(
	                'li',
	                null,
	                Glamor.createElement(
	                  _gatsbyLink2.default,
	                  { css: style.link, activeClassName: 'active', to: '/contact-us' },
	                  'Contact Us'
	                )
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { css: [_button.buttonGroupStyle.horizontal, style.buttons] },
	              Glamor.createElement(
	                'a',
	                { css: [_button.buttonStyle.button, _button.buttonStyle.outline], href: 'https://www.youtube.com/embed/7oTDpRya7Ko?autoplay=1', target: '_blank' },
	                'Watch the video'
	              ),
	              Glamor.createElement(
	                _gatsbyLink2.default,
	                { css: [_button.buttonStyle.button, _button.buttonStyle.filled], to: '/contact-us' },
	                'Book a demo'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2.default.Component);
	
	exports.default = Navbar;
	;
	
	var style = {
	  navbar: (_navbar = {
	    position: 'fixed',
	    top: '0',
	    width: '100%',
	    backgroundColor: '#FFFFFF',
	    boxShadow: '0 2px 4px #DDE5ED',
	    zIndex: '1000'
	  }, _navbar[_presets2.default.Desktop] = {
	    height: '80px'
	  }, _navbar[_presets2.default.Tablet] = {
	    height: '60px'
	  }, _navbar[_presets2.default.Mobile] = {
	    height: '60px'
	  }, _navbar),
	  inner: {
	    padding: '0 20px 0 20px'
	  },
	  hamburger: (_hamburger = {}, _hamburger[_presets2.default.Desktop] = {
	    display: 'none'
	  }, _hamburger[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    position: 'relative',
	    height: '30px',
	    width: '30px',
	    margin: '15px 0'
	  }, _hamburger[_presets2.default.Mobile] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    position: 'relative',
	    height: '30px',
	    width: '30px',
	    margin: '15px 0'
	  }, _hamburger),
	  hamburgerIcon: (_hamburgerIcon = {}, _hamburgerIcon[_presets2.default.Desktop] = {
	    display: 'none'
	  }, _hamburgerIcon[_presets2.default.Tablet] = {
	    position: 'absolute',
	    marginTop: '15px',
	    display: 'inline-block',
	    width: '30px',
	    height: '2px',
	    borderTop: '2px solid #4F739A',
	    '-webkit-transition': 'border-color .1s',
	    transition: 'border-color .1s',
	    ':before, :after': (_beforeAfter = {
	      content: '" "',
	      position: 'absolute',
	      borderTop: '2px solid #4F739A',
	      height: 0,
	      left: 0,
	      right: 0,
	      '-webkit-transition': '-webkit-transform .2s',
	      transition: '-webkit-transform .2s'
	    }, _beforeAfter['transition'] = 'transform .2s', _beforeAfter['transition'] = 'transform .2s, -webkit-transform .2s', _beforeAfter)
	  }, _hamburgerIcon[_presets2.default.Mobile] = {
	    position: 'absolute',
	    marginTop: '15px',
	    display: 'inline-block',
	    width: '30px',
	    height: '2px',
	    borderTop: '2px solid #4F739A',
	    '-webkit-transition': 'border-color .1s',
	    transition: 'border-color .1s',
	    ':before, :after': (_beforeAfter2 = {
	      content: '""',
	      position: 'absolute',
	      borderTop: '2px solid #4F739A',
	      height: 0,
	      left: 0,
	      right: 0,
	      '-webkit-transition': '-webkit-transform .2s',
	      transition: '-webkit-transform .2s'
	    }, _beforeAfter2['transition'] = 'transform .2s', _beforeAfter2['transition'] = 'transform .2s, -webkit-transform .2s', _beforeAfter2)
	  }, _hamburgerIcon[':before'] = {
	    top: '-10px'
	  }, _hamburgerIcon[':after'] = {
	    bottom: '-6px'
	  }, _hamburgerIcon),
	  actions: (_actions = {}, _actions[_presets2.default.Desktop] = {
	    float: 'right'
	  }, _actions[_presets2.default.Tablet] = {
	    margin: '-3px -20px 0 -20px',
	    overflowY: 'hidden',
	    height: '0px',
	    '-webkit-transition': 'height .2s ease-out',
	    '-moz-transition': 'height .2s ease-out',
	    '-ms-transition': 'height .2s ease-out',
	    '-o-transition': 'height .2s ease-out',
	    transition: 'height .2s ease-out',
	    '&[data-navbar-open=true]': {
	      height: '245px'
	    }
	  }, _actions[_presets2.default.Mobile] = {
	    marginLeft: '-20px',
	    marginRight: '-20px',
	    background: 'rgba(255, 255, 255, .8)',
	    boxShadow: '0 2px 4px #DDE5ED',
	    overflowY: 'hidden',
	    height: '0px',
	    '-webkit-transition': 'height .2s ease-out',
	    '-moz-transition': 'height .2s ease-out',
	    '-ms-transition': 'height .2s ease-out',
	    '-o-transition': 'height .2s ease-out',
	    transition: 'height .2s ease-out',
	    '&[data-navbar-open=true]': {
	      height: '310px'
	    }
	  }, _actions),
	  links: (_links = {
	    margin: 0,
	    padding: 0
	  }, _links[_presets2.default.Desktop] = {
	    display: 'block',
	    float: 'left',
	    height: '100%',
	    '& li': {
	      float: 'left'
	    }
	  }, _links[_presets2.default.Tablet] = {
	    background: 'rgba(255, 255, 255, .8)',
	    boxShadow: '0 2px 4px #DDE5ED'
	  }, _links[_presets2.default.Mobile] = {
	    display: 'block',
	    width: '100%'
	  }, _links['& li'] = {
	    display: 'block'
	  }, _links),
	  buttons: (_buttons = {
	    padding: 0
	  }, _buttons[_presets2.default.Desktop] = {
	    display: 'block',
	    float: 'left',
	    height: '100%',
	    margin: '10px 0 10px 20px',
	    '& li': {
	      display: 'block',
	      float: 'left'
	    }
	  }, _buttons[_presets2.default.Tablet] = {
	    position: 'absolute',
	    top: 0,
	    right: 0,
	    '& li': {
	      display: 'block',
	      float: 'left'
	    }
	  }, _buttons[_presets2.default.Mobile] = {
	    display: 'block',
	    height: '100%',
	    marginLeft: '20px',
	    '& li': {
	      display: 'inline-block'
	    }
	  }, _buttons),
	  link: (_link = {
	    display: 'block',
	    color: '#4F739A',
	    margin: 0,
	    minWidth: '80px',
	    textDecoration: 'none',
	    userSelect: 'none',
	    '-moz-user-select': 'none',
	    '-webkit-user-select': 'none',
	    '-ms-user-select': 'none',
	    '-moz-transition': 'background .2s',
	    '-o-transition': 'background .2s',
	    '-webkit-transition': 'background .2s',
	    transition: 'background .2s'
	  }, _link[_presets2.default.Desktop] = {
	    textAlign: 'center',
	    padding: '30.5px 20px 30.5px 20px'
	  }, _link[_presets2.default.Tablet] = {
	    textAlign: 'left',
	    padding: '20.5px 12px 20.5px 12px'
	  }, _link[_presets2.default.Mobile] = {
	    textAlign: 'left',
	    padding: '20.5px 20px 20.5px 20px'
	  }, _link['&:hover, &:focus, &:active'] = {
	    fontWeight: 'normal',
	    background: '#F4F8FC'
	  }, _link['&.active'] = {
	    fontWeight: 'bold',
	    background: '#F4F8FC'
	  }, _link),
	  logo: (_logo = {
	    position: 'relative',
	    top: '13px',
	    userSelect: 'none',
	    '-moz-user-select': 'none',
	    '-webkit-user-select': 'none',
	    '-ms-user-select': 'none'
	  }, _logo[_presets2.default.Desktop] = {
	    top: '16px',
	    height: '45px'
	  }, _logo[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    top: '13px',
	    left: '20px',
	    height: '32px'
	  }, _logo[_presets2.default.Mobile] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    top: '13px',
	    left: 'calc(50% - 85px)',
	    height: '32px'
	  }, _logo)
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/fonts/fonts.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./src/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _marginSalesSite;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _salesNavbar = __webpack_require__("./src/components/sales-navbar.js");
	
	var _salesNavbar2 = _interopRequireDefault(_salesNavbar);
	
	var _salesFooter = __webpack_require__("./src/components/sales-footer.js");
	
	var _salesFooter2 = _interopRequireDefault(_salesFooter);
	
	var _blogNavbar = __webpack_require__("./src/components/blog-navbar.js");
	
	var _blogNavbar2 = _interopRequireDefault(_blogNavbar);
	
	var _blogFooter = __webpack_require__("./src/components/blog-footer.js");
	
	var _blogFooter2 = _interopRequireDefault(_blogFooter);
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	__webpack_require__("./src/fonts/fonts.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultLayout = function (_React$Component) {
	  _inherits(DefaultLayout, _React$Component);
	
	  function DefaultLayout() {
	    _classCallCheck(this, DefaultLayout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DefaultLayout.prototype.render = function render() {
	
	    //For staging on GitHub pages, find the sub-directory in the URL and extract it
	    var isBlog = this.props.location.pathname.replace('/' + this.props.data.site.siteMetadata.gitRepo, '').slice(0, 5) === '/blog';
	    console.log('pathname:', this.props.location.pathname);
	    console.log('pathname stripped:', this.props.location.pathname.replace('/' + this.props.data.site.siteMetadata.gitRepo, ''));
	
	    var Navbar = Glamor.createElement(_salesNavbar2.default, null);
	    var Footer = Glamor.createElement(_salesFooter2.default, { navigation: this.props.data.allPrismicDocument.edges });
	
	    if (isBlog) {
	      Navbar = Glamor.createElement(_blogNavbar2.default, null);
	      Footer = Glamor.createElement(_blogFooter2.default, null);
	    }
	
	    return Glamor.createElement(
	      'div',
	      { css: isBlog ? style.marginBlogSite : style.marginSalesSite },
	      Glamor.createElement(
	        _reactHelmet.Helmet,
	        { defaultTitle: 'Home care software that works', titleTemplate: '%s | CarePlanner' },
	        Glamor.createElement('link', { rel: 'icon', href: __webpack_require__("./src/assets/favicon.ico"), type: 'image/x-icon' }),
	        Glamor.createElement('meta', { name: 'description', content: 'CarePlanner gives domiciliary home care agencies the power to plan and manage staff rosters, client schedules, invoicing and timesheets.' }),
	        Glamor.createElement('meta', { property: 'og:type', content: 'website' }),
	        Glamor.createElement('meta', { property: 'og:title', content: 'CarePlanner' }),
	        Glamor.createElement('meta', { property: 'og:description', content: 'CarePlanner gives domiciliary home care agencies the power to plan and manage staff rosters, client schedules, invoicing and timesheets.' }),
	        Glamor.createElement('meta', { name: 'twitter:title', content: 'CarePlanner' }),
	        Glamor.createElement('meta', { name: 'twitter:description', content: 'CarePlanner gives domiciliary home care agencies the power to plan and manage staff rosters, client schedules, invoicing and timesheets.' })
	      ),
	      Navbar,
	      this.props.children(),
	      Footer
	    );
	  };
	
	  return DefaultLayout;
	}(_react2.default.Component);
	
	exports.default = DefaultLayout;
	;
	
	var style = {
	  marginSalesSite: (_marginSalesSite = {}, _marginSalesSite[_presets2.default.Desktop] = {
	    paddingTop: '80px'
	  }, _marginSalesSite[_presets2.default.Tablet] = {
	    paddingTop: '60px'
	  }, _marginSalesSite[_presets2.default.Mobile] = {
	    paddingTop: '60px'
	  }, _marginSalesSite),
	  marginBlogSite: {
	    paddingTop: '60px'
	  }
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-5e4a4c2fa6a5b0400d24.js